const { MAX_SAFE_INTEGER } = require("core-js/fn/number");

import '../css/main.css';
import '../components/hanzi-pinyin.ts';